// Google Tag Manager utility functions
const GTM_ID = 'GTM-T8WFJGSQ';

declare global {
  interface Window {
    dataLayer: any[];
    google_tag_manager?: any;
  }
}

/**
 * Initialize Google Tag Manager
 * Only call this function when user has accepted cookies
 */
export const initGTM = (): void => {
  // Check if GTM is already loaded
  if (window.google_tag_manager) {
    return;
  }

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });

  // Load GTM script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode?.insertBefore(script, firstScript);

  // Add noscript iframe for GTM
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);

};

/**
 * Disable Google Tag Manager and clear tracking cookies
 */
export const disableGTM = (): void => {
  // Clear dataLayer
  if (window.dataLayer) {
    window.dataLayer = [];
  }

  // Remove GTM cookies
  const gtmCookies = document.cookie.split(';').filter(cookie =>
    cookie.trim().startsWith('_ga') ||
    cookie.trim().startsWith('_gid') ||
    cookie.trim().startsWith('_gat')
  );

  gtmCookies.forEach(cookie => {
    const cookieName = cookie.split('=')[0].trim();
    // Delete cookie for current domain
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    // Delete cookie for parent domain
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
  });

};

/**
 * Push event to dataLayer (only if GTM is initialized)
 */
export const pushToDataLayer = (data: Record<string, any>): void => {
  if (window.dataLayer) {
    window.dataLayer.push(data);
  }
};

/**
 * Check if user has consented to cookies
 */
export const hasConsent = (): boolean => {
  const consent = localStorage.getItem('cookieConsent');
  return consent === 'accepted';
};

/**
 * Initialize GTM if user has already consented
 * Call this on app load
 */
export const initGTMIfConsented = (): void => {
  if (hasConsent()) {
    initGTM();
  }
};
